import styled from "styled-components";

import { Button as StyledButton } from "components/atoms/Button";
import { colourScheme } from "utils/styling/colours";

export const ReplyForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    background-color: ${colourScheme.primary};
    border-radius: 0.5rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const TextArea = styled.textarea`
    width: 100%;
    height: auto;
    padding: 1rem;
    border: 1px solid ${colourScheme.primaryDark};
    background-color: ${colourScheme.primaryLight};
    color: ${colourScheme.white};
    border-radius: 0.5rem;
    resize: none;
    font-size: 1rem;
    font-family: inherit;

    &:focus {
        outline: none;
        border-color: ${colourScheme.secondary};
    }
`;

export const Button = styled(StyledButton)`
    color: white;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;

    &:focus {
        outline: none;
    }
`;
